import React, { useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined"
import { reviewPendingVacationRequest } from "../../../../services/vacation.service"
import useToast from "../../../../hooks/useToast.hook"
import VacationRequestSummary from "../../components/VacationRequestSummary.molecule"
import DangerButton from "../../../../components/molecules/buttons/DangerButton.molecule"
import ModalFormRejectVacationRequest from "./ModalFormRejectVacationRequest.controller"
import {
  VACATIONS_APPROVE_VACATION_REQUEST_SUCCESS,
  VACATIONS_SAVE_ERROR_MESSAGE,
} from "../../../../consts/modules/vacations.consts"
import { useSession } from "../../../../hooks/auth/useSession.hook"

const ModalFormVacationRequestReview = ({
  visible,
  setVisible,
  selectedVacationRequest,
  triggerRefresh,
}) => {
  const { user } = useSession()
  const thisVacationWasCreatedByMe =
    selectedVacationRequest?.createdBy === user?.id

  const [submitting, setSubmitting] = useState(false)
  const [rejectModalVisible, setRejectModalVisible] = useState(false)

  const { setSuccessMessage, setErrorMessage } = useToast()

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await reviewPendingVacationRequest(
        selectedVacationRequest.idVacations,
        selectedVacationRequest.vacationRangeId,
        true,
        null
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      setVisible(false)
      triggerRefresh()
      setSuccessMessage(VACATIONS_APPROVE_VACATION_REQUEST_SUCCESS)
    } catch (error) {
      setErrorMessage(VACATIONS_SAVE_ERROR_MESSAGE)
    } finally {
      setSubmitting(false)
    }
  }

  const modalFooterTemplate = () => {
    return (
      <div>
        <DangerButton
          label="Rechazar"
          btnType="outlined"
          icon={`pi pi-times`}
          onClick={() => {
            setRejectModalVisible(true)
            setVisible(false)
          }}
          disabled={submitting}
          rounded
        />
        <PrimaryButton
          label="Aprobar"
          icon={`pi ${submitting ? "pi-spin pi-spinner" : "pi-check"}`}
          onClick={handleSubmit}
          disabled={submitting}
          rounded
        />
      </div>
    )
  }

  if (!selectedVacationRequest) {
    return null
  }
  return (
    <>
      <ModalForm
        className={`vacation-request-review-modal-form ${thisVacationWasCreatedByMe && user.isAdmin() ? "hide-actions-footer" : ""}`}
        visible={visible}
        setVisible={setVisible}
        headerTitle="Solicitud de vacaciones"
        footer={modalFooterTemplate()}
        headerIcon={
          <BeachAccessOutlinedIcon
            style={{ color: "var(--clr-info__dark)", fontSize: "32px" }}
          />
        }
        dismissableMask
        closable
      >
        <VacationRequestSummary vacationRequest={selectedVacationRequest} />
      </ModalForm>
      <ModalFormRejectVacationRequest
        visible={rejectModalVisible}
        setVisible={setRejectModalVisible}
        setParentVisible={setVisible}
        vacationRequest={selectedVacationRequest}
        triggerRefresh={triggerRefresh}
      />
    </>
  )
}

export default ModalFormVacationRequestReview

ModalFormVacationRequestReview.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedVacationRequest: PropTypes.object,
  triggerRefresh: PropTypes.func,
}
